import { historyExportFormActions } from '../../actions'
import { useActions, useAppSelector } from '../../../../store/hooks'
import { exportSelector } from '../../../../store/slices/export'
import { historyPageSelector } from '../../../../store/slices/historyPage'
import { historySelector } from '../../../../store/slices/history'
import { referencesSelector } from '../../../../store/slices/references'

export function useHistoryExportForm() {
    const groups = useAppSelector(referencesSelector.groups)
    const selectedGroupId = useAppSelector(historyPageSelector.selectedGroupId)
    const selectedGroupName = useAppSelector(historyPageSelector.selectedGroupName)
    const saveOnServer = useAppSelector(historyPageSelector.saveOnServer)
    const exporting = useAppSelector(exportSelector.isExporting)
    const generating = useAppSelector(historySelector.generating)
    const exportNotice = useAppSelector(exportSelector.notice)
    const historyNotice = useAppSelector(historySelector.notice)
    const exportError = useAppSelector(exportSelector.error)
    const historyError = useAppSelector(historySelector.error)

    const {
        setExportGroup,
        setSaveOnServer,
        scheduleExport,
        historyGenerate,
        resetExportNotice,
    } = useActions(historyExportFormActions)

    const error = exportError || historyError
    const notice = exportNotice || historyNotice

    const handleGroupChange = (groupId) => {
        const group = groups.find(
            (item) => String(item.group_id || item.id) === String(groupId)
        )

        setExportGroup({
            groupId,
            groupName: group?.name || '',
        })
    }

    const handleExport = () => {
        resetExportNotice()
        scheduleExport({
            groupId: selectedGroupId,
            groupName: selectedGroupName,
            saveOnServer,
        })
    }

    return {
        groups,
        selectedGroupId,
        saveOnServer,
        exporting,
        generating,
        error,
        notice,
        setSaveOnServer,
        handleGroupChange,
        handleExport,
        handleGenerate: historyGenerate,
    }
}
